import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { listSaleChannels } from "../../../../../../services/saleChannel.service";
import { listExamMachines } from "../../../../../../services/uBusAutomationRobot";
import { useWatch } from "react-hook-form";
import { TFileIntegrationForm } from "../fileIntegrationSchema";

const translationPath = "page.4uBus.uBusAutomationRobot.";

export const ExamMachineSelect = memo(() => {
  const { t } = useTranslation();

  const [options, setOptions] = useState<ISelectType[]>([]);

  const { sendRequest } = useFetch(listExamMachines);

  const { control } = useFormContext<TFileIntegrationForm>();

  const examMachineModality = useWatch({
    name: "examMachineModality",
    control,
  });

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest({
      ExamMachineModalityCodes: examMachineModality
        ? [examMachineModality.code]
        : undefined,
    });
    if (data && success) {
      setOptions(data);
    }
  }, [sendRequest, examMachineModality]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <AutoComplete
      name="examMachine"
      label={t(translationPath + "exam_machine")}
      getOptionLabel={(option) => option.name}
      size="small"
      fullWidth
      options={options}
      disable={!examMachineModality}
    />
  );
});
